import React from "react";
import { Link, makeStyles, Typography } from "@material-ui/core/";
import GitInfo from "react-git-info/macro";
import packageJson from "../../../package.json";
import translate from "../../i18n/translate";
import { CHAT_HEIGHT } from "../../constants";

const gitInfo = GitInfo();

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: "auto",
    textAlign: "center",
    padding: "4rem 0px 1.5rem 0px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    color: theme.palette.grey[500],
    [theme.breakpoints.down("xs")]: {
      marginBottom: `${CHAT_HEIGHT}px`,
    },
  },
  item: {
    marginRight: "1rem",
    color: theme.palette.grey[700],
    cursor: "pointer",
    "&:hover": {
      color: theme.palette.primary.main,
      textDecoration: "none",
    },
  },
}));

const Footer = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Link
        className={classes.item}
        href="https://senorpago.com/avisodeprivacidad"
        target="_blank"
        variant="caption"
      >
        {translate("footer.NoticeOfPrivacy")}
      </Link>
      <Link
        className={classes.item}
        href="https://senorpago.com/terminosycondiciones"
        target="_blank"
        variant="caption"
      >
        {translate("footer.TermsAndConditions")}
      </Link>
      <Typography
        variant="caption"
        title={`My v${packageJson.version} - ${gitInfo.commit.shortHash}`}
      >
        {translate("footer.SrPago")}
      </Typography>
    </div>
  );
};

export default Footer;
